<script lang="ts" setup>
import { Button } from '@forgd/ui-kit/button'
import { ArrowRightIcon } from '@heroicons/vue/24/outline'

interface AcademyCard {
  category: string
  question: string
}

const cards: AcademyCard[] = [
  { category: 'Tokenomics 101', question: 'What are Tokenomics?' },
  { category: 'Market Making 101', question: 'Why do I need to work with a professional market maker?' },
  { category: 'Exchange Listing 101', question: 'What are the best centralized exchanges to list my token on?' },
  { category: 'Go-to-Market Budgeting 101', question: 'How much does it cost to work with a market maker?' },
]

const marqueeCards = Array.from<AcademyCard[]>({ length: 5 }).fill(cards).flat()
</script>

<template>
  <section data-el="CoreAcademyStrip" class="w-full max-w-full min-w-0 overflow-x-clip">
    <div class="flex min-w-0 flex-col gap-4">
      <div class="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
        <div class="min-w-0 flex flex-col gap-2">
          <div class="flex items-center gap-1">
            <img src="/images/academy/forgd-academy-cap.svg" alt="" class="size-5 shrink-0">
            <h3 class="text-xs font-semibold leading-[18px] text-primal">
              Forgd Academy
            </h3>
          </div>
          <p class="text-sm leading-[21px] text-primal">
            100+ FAQs teaching the fundamentals behind tokenomics, market makers, and more.
          </p>
        </div>
        <Button as-child variant="outline" size="sm" class="shrink-0 self-start">
          <NuxtLink to="/academy">
            Explore Academy Chapters
            <ArrowRightIcon />
          </NuxtLink>
        </Button>
      </div>
      <div class="academy-marquee-fade w-full min-w-0 overflow-hidden">
        <ul class="academy-marquee-track flex">
          <li v-for="(card, i) in marqueeCards" :key="`${card.question}-${i}`" class="shrink-0 pr-3">
            <NuxtLink
              to="/academy"
              class="flex h-21.5 w-65 items-center gap-2 rounded-lg bg-white p-3 transition-colors hover:bg-secondary-subtle"
            >
              <div class="flex flex-1 flex-col gap-2">
                <span class="text-xs leading-4.5 text-[#434329]">{{ card.category }}</span>
                <span class="text-xs leading-4.5 text-primal">{{ card.question }}</span>
              </div>
              <ArrowRightIcon class="size-4 shrink-0 text-primal" />
            </NuxtLink>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<style scoped>
.academy-marquee-fade {
  -webkit-mask-image: linear-gradient(to right, transparent 0, black 72px, black calc(100% - 72px), transparent 100%);
  mask-image: linear-gradient(to right, transparent 0, black 72px, black calc(100% - 72px), transparent 100%);
}

.academy-marquee-track {
  width: max-content;
  animation: academy-marquee 40s linear infinite;
}

/* Stops on hover so a card can be read / clicked. */
.academy-marquee-fade:hover .academy-marquee-track {
  animation-play-state: paused;
}

@keyframes academy-marquee {
  from {
    transform: translateX(0);
  }
  /* one set = 1/5 of the track */
  to {
    transform: translateX(-20%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .academy-marquee-track {
    animation: none;
  }
}
</style>
